import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhCampaignAllocations extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhCampaignAllocations'
  // Define default properties here
  static instanceDefaults() {
    return {
      campaign_id: null,
      target_type: 'INDIVIDUAL',
      target_id: null,
      tokens_allocated: 0,
      tokens_per_rating: 0,
      tokens_distributed: 0,
      tokens_refunded: 0,
      group_admin_percentage: null,
      group_member_percentage: null,
      date_created: null
    }
  }
}
const servicePath = 'bh-campaign-allocations';
const servicePlugin = makeServicePlugin({
  Model: BhCampaignAllocations,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
